<template>
  <div
    :class="['layout', _isMobile() ? 'mobile' : '']"
    :style="{
      'background-image': 'url(' + tenantConfig.json_homeBg.image + ')',
      'background-repeat': tenantConfig.json_homeBg.repeat,
      'background-color': tenantConfig.json_homeBg.color,
      'background-size': tenantConfig.json_homeBg.size,
    }"
  >
    <div class="home">
      <router-view />
    </div>
    <a-back-top />
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { mixinDevice } from "@/utils/mixin.js";

export default {
  name: "BlankLayout",
  mixins: [mixinDevice],
  components: {},
  data() {
    return {
      tenantConfig: {},
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
  },
};
</script>
<style>
a * {
  transition: all 0.1s ease;
}
</style>
<style lang="less" scoped>
.layout {
  // padding-top: 90px;
  background: #f2f6f8;
  .home {
    max-width: 1200px;
    margin: auto;
    padding: 20px;
    background: #ffffffd1;
    border-radius: 30px;
    min-height: 100vh;
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
}
</style>